module.exports = __webpack_public_path__ + "img/ann.25b090d7.png";